export default __webpack_public_path__ + "static/media/roast-pork.64059a2a.svg";